export const BaseLineApi = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.9092 5.15517L14.1983 5.16082C14.4745 5.1613 14.698 5.38554 14.6975 5.66168L14.6753 18.555C14.6749 18.8312 14.4506 19.0547 14.1745 19.0542L10.8854 19.0485C8.99078 19.0453 3.9419 17.1421 3.95064 12.0899C3.95931 7.0378 9.01463 5.15199 10.9092 5.15517Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M15.0002 15.4808L18.6571 15.4905"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M1.00078 11.2499C0.586571 11.2499 0.250783 11.5857 0.250782 11.9999C0.250781 12.4141 0.586567 12.7499 1.00078 12.7499L1.00078 11.2499ZM1.00078 12.7499L4.00064 12.7499L4.00064 11.2499L1.00078 11.2499L1.00078 12.7499Z"
      fill="currentColor"
    />
    <path
      d="M15.0002 8.72103L18.6571 8.73075"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path d="M22 6.29736V17.8974" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
  </svg>
);
